import { GrIconType } from "@jnpmedi/grebob";

export const enum NaviType {
  Navi = "NAVI",
  Divider = "DIVIDER",
}

export const enum NaviKey {
  MyDocuments = "MY_DOCUMENTS",
  SignStatus = "SIGN_STATUS",
  Contacts = "CONTACTS",
  Archiver = "ARCHIVER",
  Templates = "TEMPLATES",
  EConsent = "ECONSENT",
  TMF = "TMF",
}

export type LinkType = {
  url: string;
  isExternal?: boolean;
  target?: "_blank" | "_self";
};

export type Navi = {
  type: NaviType.Navi;
  key: NaviKey;
  label: string;
  link: LinkType;
  startIcon?: GrIconType;
  endIcon?: GrIconType;
  isHidden?: boolean;
};

export type NaviDivider = {
  type: NaviType.Divider;
  isVisibleLine: boolean;
  isHidden?: boolean;
};
